module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/components/Building/images/transportation-unit-lvl3-50.d15aaec0.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Building/images/transportation-unit-lvl3-50.png
// module id = 3352
// module chunks = 11